module.exports = __webpack_public_path__ + "img/pre.00c62a7e.svg";